import React, { useState } from "react";
import { Form, Input, Button, Select, Row, Col, message, DatePicker,Typography } from "antd";
import { useHistory } from "react-router-dom";
import LeftLayout from "../pageHeader/LeftLayout";
import _NewapplicationService from "../../modules/NewapplicationService";
import { APPLICATION_SUBMIT_SUCCESSFULLY, SUBMISSION_FAILED } from "../../constants/constants";
import { routes } from "../../routes/Routes";
import { LeftOutlined, RightOutlined} from '@ant-design/icons';

const { Option } = Select;
const { Title, Text } = Typography;

const Liquidity = () => {
    const [loading, setLoading] = useState(false);
    const history = useHistory();
    const onFinish = async (values) => {
        history.push(routes.ProofOfTrust.path);
        // setLoading(true);
        // let reqObj = {
        //     applicationType: values.applicationType,
        //     firstName: values.firstName,
        //     lastName: values.lastName,
        //     dob: values.dob,
        //     contactNumber: values.contactNumber,
        //     loanAmount: values.loanAmount,
        // }
        // try {
        //     const res = await _NewapplicationService.submitApplicantDetails(reqObj);
        //     if (res.data.isSuccess) {
        //         setLoading(false);
        //         message.success(APPLICATION_SUBMIT_SUCCESSFULLY);
        //         //  history.push("/verifyotp");
        //     }
        // } catch (err) {
        //     setLoading(false);
        //     message.error(err.message || SUBMISSION_FAILED);
        // }
        // finally {
        //     setLoading(false);
        // }

    };

    const onBack = () => {
        history.push(routes.uploaddocuments.path);
    }

    const onNext = () => {
        history.push(routes.realestateassets.path);
    }

    return (
        <LeftLayout>
            <Row style={{ maxWidth:600 }}>
                <Col span={24}>
                    <Title level={3} style={{ marginBottom: 25}}> Liquidity </Title>
                    <Form
                        layout="vertical"
                        onFinish={onFinish}
                        initialValues={{ applicationType: undefined }}
                    >
                        <Form.Item
                            label="Cash"
                            name="cash"
                            rules={[
                                { required: true, message: "Cash is required" },
                                // {
                                //     pattern: /^\d+(\.\d{1,2})?$/,
                                //     message: "Enter a valid Cash",
                                // },
                            ]}
                        >
                            <Input placeholder="$" />
                        </Form.Item>

                        <Form.Item
                            label="MarkeTable Securities"
                            name="markeTableSecurities"
                            rules={[
                                { required: true, message: "MarkeTable Securities is required" },
                                // {
                                //     pattern: /^\d+(\.\d{1,2})?$/,
                                //     message: "Enter a valid amount",
                                // },
                            ]}
                        >
                            <Input placeholder="$" />
                        </Form.Item>

                        <Form.Item>
                            <div style={{ display: "flex", gap: 16,marginTop:20}}>
                                <Button
                                    onClick={onBack}
                                    icon={<LeftOutlined />}
                                >
                                    Go Back
                                </Button>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                >
                                    Save And Proceed <RightOutlined />
                                </Button>
                                <Button
                                    type="default"
                                    onClick={onNext}
                                >
                                    Next <RightOutlined />
                                </Button>
                            </div>
                        </Form.Item>
                    </Form>
                </Col>
            </Row>
        </LeftLayout >
    );
};

export default Liquidity;